import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { SummaryInfoDto } from 'src/app/web/interfaces/project/list/summaryInfoDto';
import Swal from 'sweetalert2';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import * as moment from 'moment';

class createRisk{
  project_id        : number;
  project_stages_id : number;
  name              : string;
  description   : string;
  activation_date    : string;
  deadline_date      : string;
  probability       : string;
  impact            : string;
  impact_description        : string;
  users_id            : number;
  username            : string;
}


@Component({
  selector: 'app-risks-create',
  templateUrl: './risks-create.component.html',
  styleUrls: ['./risks-create.component.scss']
})


export class RisksCreateComponent implements OnInit {

  createRiskForm: FormGroup;
  idProject:number;

  listStage: any[] = [];
  listImpact: any[] =[];
  listProbability: any[] = [];
  listPerson: any[] = [];
  // listRisksMatrix: createRisk; 

  username : string;
  createRisk : createRisk;

  summaryInfoDto: SummaryInfoDto = {} as SummaryInfoDto;

  constructor(private apiService: ApiServiceProject,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private fb: FormBuilder,
              private spinner: NgxSpinnerService,
              private errorService:ErrorService) { 
   this.activatedRoute.params.subscribe(params => {
     this.idProject = params['id'];
    })
  }

  ngOnInit(): void {

    this.summaryInfoDto.title = localStorage.getItem("title");
    
    this.createRiskForm = this.fb.group({
      project_stages_id :[''],
      name: [''],
      description: [''],
      activation_date: [''],
      deadline_date: [''],
      probability: [''],
      impact: [''],
      impact_description: [''],
      users_id: [''],
    });
    
    this.spinner.show();
    // Validacion y optencion de combobox
    this.apiService.getService(`project-view-risks?id_project=${this.idProject}`)
    .subscribe({
      next: (data:any) =>{

        if (data.code == null) {
          if (data == '' || data == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) =>{
              if (res.isConfirmed || res.isDismissed) {
                this.router.navigate(['home']);
              }
            })
          }

          this.listStage = data.listDependence;
          this.listImpact = data.listImpact;
          this.listProbability = data.listProbabilty;
          this.listPerson = data.listAssigned;
        this.spinner.hide();
        }else{
          this.spinner.hide();
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });

  }

  // Validaciones y envios de formulario
  formSubmit(): void {
    this.spinner.show();

    if (this.createRiskForm.value.project_stages_id === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una etapa',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createRiskForm.value.name === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un nombre para el riesgo',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createRiskForm.value.description === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una descripcion',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createRiskForm.value.activation_date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una fecha de activacion',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createRiskForm.value.deadline_date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una fecha de deadline',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createRiskForm.value.probability === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una probabilidad',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createRiskForm.value.impact === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un impacto',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createRiskForm.value.impact_description === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una descripcion de impacto',text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.createRiskForm.value.users_id === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un responsable',text: '',icon: 'error',heightAuto: false});
      return;
    }


    this.createRisk = new createRisk();

    this.createRisk.project_id = this.idProject;
  
    // this.listPerson.map((dato)=>{ if(dato.id == this.createRisk.person) { this.username = dato.nombre } })
    let name = this.listPerson.filter( n =>  Number(n.users_id) == Number(this.createRiskForm.value.users_id))

    this.createRisk.project_id = Number(this.idProject);
    this.createRisk.impact = this.createRiskForm.value.impact.toString()
    this.createRisk.probability = this.createRiskForm.value.probability.toString()
    this.createRisk.project_stages_id = Number(this.createRiskForm.value.project_stages_id);
    this.createRisk.users_id = Number(this.createRiskForm.value.users_id);
    this.createRisk.activation_date =  moment(this.createRiskForm.value.activation_date).format("DD-MM-YYYY"); 
    this.createRisk.deadline_date = moment(this.createRiskForm.value.deadline_date).format("DD-MM-YYYY");
    this.createRisk.username = name[0].username
    this.createRisk.name = this.createRiskForm.value.name;
    this.createRisk.impact_description = this.createRiskForm.value.impact_description;
    this.createRisk.description = this.createRiskForm.value.description;




      this.apiService
      .postService('project-view-risks-create',this.createRisk)
      .subscribe({
        next: (data:any)=>{
          if(data.message){
          this.spinner.hide();
          // this.listRisksMatrix = this.createRisk;
          Swal.fire({title:'Se ha creado el riesgo correctamente' ,text: '',icon: 'success',heightAuto: false})
          .then(( ) =>[this.router.navigate(['/pdg/project/list/view',this.idProject ])] );
        }else{
          this.spinner.hide();
          Swal.fire({title:data.error ,text: '',icon: 'error',heightAuto: false}).then((dato)=>{
          });
        }

        },
        error: (error) => {
          this.errorService.error(error);
        },
      });
    
    

  }



}
